export default __webpack_public_path__ + "static/media/This is what I take pride in.610a2188.mp4";